import { IKlaviyoDetailObject } from '@/core/constants/sources_types/klaviyo_form_types';
import { TsUtilityFunctions } from '@/core/event_logic/utils/ts_utils';

import {
  AbstractLeadFormEventTrigger,
  CustomerDataDetectWtagInput,
} from './abstract_lead_event';

export class LeadKlaviyoEventTrigger extends AbstractLeadFormEventTrigger {
  override registerEvent() {
    window.addEventListener('klaviyoForms', async (e: any) => {
      const klaviyoDetail = e.detail as IKlaviyoDetailObject;
      const customer_data: CustomerDataDetectWtagInput = {
        email: TsUtilityFunctions.wrapValueWithArray(
          klaviyoDetail.metaData?.$email,
        ),
        firstName: TsUtilityFunctions.wrapValueWithArray(
          klaviyoDetail.metaData?.$first_name,
        ),
        lastName: TsUtilityFunctions.wrapValueWithArray(
          klaviyoDetail.metaData?.$last_name,
        ),
        phone: TsUtilityFunctions.wrapValueWithArray(
          klaviyoDetail.metaData?.$phone_number,
        ),
      };
      this.handleEventTriggered(customer_data, 'lead_klaviyo');
    });
  }
}
